export default __webpack_public_path__ + "static/media/search-active-icon.b1b6cdae.svg";